/**
 * ampel.ts — the shared Ampel → StatusDot tone + German label maps (P2 Placement).
 *
 * Lifted out of BasisspartenSection (Slice 1) so the Police-Ebene Soll-Deckung table (Slice 2)
 * renders the SAME four-colour Ampel through the same StatusDot tones. BASISSPARTEN_AMPEL and the
 * Police DECKUNG_AMPEL are the same vocab (gruen/gelb/rot/grau), so one map serves both.
 */

import { BASISSPARTEN_AMPEL } from '@brokly/shared';
import type { BasisspartenAmpel } from '@brokly/shared';
import type { StatusTone } from '../../../../components/ui/StatusDot';

/** Ampel colour → StatusDot tone. */
export const AMPEL_TONE: Record<BasisspartenAmpel, StatusTone> = {
  [BASISSPARTEN_AMPEL.GRUEN]: 'success',
  [BASISSPARTEN_AMPEL.GELB]: 'warning',
  [BASISSPARTEN_AMPEL.ROT]: 'danger',
  [BASISSPARTEN_AMPEL.GRAU]: 'neutral',
};

/** Ampel colour → German status label. */
export const AMPEL_LABEL: Record<BasisspartenAmpel, string> = {
  [BASISSPARTEN_AMPEL.GRUEN]: 'Abgedeckt',
  [BASISSPARTEN_AMPEL.GELB]: 'Zu pruefen',
  [BASISSPARTEN_AMPEL.ROT]: 'Pflicht offen / Luecke',
  [BASISSPARTEN_AMPEL.GRAU]: 'Nicht relevant',
};
